import { WEDDING_DATE } from 'resources/constants'

import Hero from 'components/Hero'
import Navbar from 'components/Navbar'
import OurStory from 'components/OurStory'
import DateCountdown from 'components/DateCountdown'
import Venue from 'components/Venue'
import Intro from 'components/Intro'
import Info from 'components/Info'
import Gifts from 'components/Gifts'

function Home() {
	return (
		<>
			<Hero />
			<Navbar />
			<Intro />
			<DateCountdown time={WEDDING_DATE} />
			<OurStory />
			<Info />
			<Gifts />
			<Venue />
		</>
	)
}

export default Home
